














































































/*
    * Method for pupulate text input control - STARTS
*/
import Vue from 'vue';
import Vuex from 'vuex';
import * as _ from 'lodash';
import { Component, Prop } from "vue-property-decorator";
import FormComponents from "./../../Form.vue";
import TextInput from "./../../FieldTypes/TextInput.vue";
import TextArea from "./../../FieldTypes/TextArea.vue";
import Number from "./../../FieldTypes/Number.vue";
import ComboBox from "./../../FieldTypes/ComboBox.vue";
import MultiSelect from "./../../FieldTypes/MultiSelect.vue";
import Date from "./../../FieldTypes//Date.vue";
import File from "./../../FieldTypes/File.vue";
import Spacer from "./../../FieldTypes/Spacer.vue";

/*
    * Component's properties and events
*/
@Component({
    components: {
        TextInput,
        TextArea,
        Number,
        ComboBox,
        MultiSelect,
        Date,
        File,
        Spacer
    }
})

export default class TabComponent extends Vue {
    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.$options.parent.fileName - current componets name
    */
    data() {
         // @ts-ignore
        return this.$store.state[this.$options.parent.fileName];
    }
}
